import { APIResponse, useAppQuery } from '@alluradirect/react';

interface Args {
  onSuccess?: (data?: any) => void;
  enabled?: boolean;
}

export enum SubscriptionTierID {
  Guest = 3,
  Standard = 2,
  Premium = 1,
}

interface SubscriptionTier {
  ANNUAL_FEE: string;
  BOOKING_FEE: number;
  CREDIT_CARD_FEE: number;
  DESCRIPTION: string;
  ID: number;
  IS_ALLOWED_PRIVATE_SITE: boolean;
  IS_RECOMMENDED: boolean;
  NUMBER_OF_DAYS: number;
  POINTS: string;
  RESORT_ID: number;
  SIMILAR_SITE: string;
  SUBTITLE: string;
  TAXES: SubscriptionTierTax[];
  TITLE: string;
}

interface SubscriptionTierTax {
  NAME: string;
  ID: number;
  TOTAL: string;
  RATE: number;
}

export const useRestauthSubscriptionTiersQuery = ({ onSuccess = _data => null, enabled = true }: Args = {}) => {
  const endpoint = '/RESTAUTH/subscriptiontiers/';

  return useAppQuery<APIResponse<{ SUBSCRIPTION_TIERS: SubscriptionTier[] }>>({
    endpoint,
    onSuccess,
    enabled,
    cacheTime: Infinity,
    staleTime: Infinity,
    useErrorBoundary: true,
  });
};
